import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useModal, useTranslate } from "@refinedev/core";
import { AddResponse, AddRestrictionDialog } from "./AddRestrictionDialog";
import { AddResultDialog } from "./AddResultDialog";
import { useState } from "react";

type AddRestrictionButtonProps = {
  translationPrefix: string;
  endpoint: string;
  hasDescription?: boolean;
};

export const AddRestrictionButton = (props: AddRestrictionButtonProps) => {
  const { translationPrefix, endpoint, hasDescription } = props;
  const translate = useTranslate();
  const { show, close, visible } = useModal();

  const {
    show: showResult,
    close: closeResult,
    visible: resultVisible,
  } = useModal();
  const [addResponse, setAddResponse] = useState<AddResponse | null>(null);

  const handleShowResult = (addResponse: AddResponse) => {
    setAddResponse(addResponse);
    showResult();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{ width: "100px" }}
        startIcon={<Add />}
        onClick={show}
      >
        {translate("buttons.add")}
      </Button>
      <AddResultDialog
        open={resultVisible}
        onClose={closeResult}
        addResponse={addResponse}
      />
      <AddRestrictionDialog
        open={visible}
        onClose={close}
        endpoint={endpoint}
        translationPrefix={translationPrefix}
        hasDescription={hasDescription}
        onShowResult={handleShowResult}
      />
    </>
  );
};
